import React from "react";

const Titles = () => (
  <div id="page-header">
    <h1>Outside</h1>
    <h2>Weather Stats</h2>
  </div>
);

export default Titles;
